// document.addEventListener("DOMContentLoaded", function () {
//     const dropdown = document.getElementById("state-selector");
//     const officeBlocks = document.querySelectorAll(".office-block");
//     const statesSet = new Set();

//     // Collect unique states from office blocks
//     officeBlocks.forEach(block => {
//       const state = block.getAttribute("data-state");
//       if (state) {
//         statesSet.add(state.trim()); // Set ensures uniqueness
//       }
//     });

//     // Convert to array and sort A-Z
//     const sortedStates = Array.from(statesSet).sort((a, b) => a.localeCompare(b));

//     // Populate dropdown options
//     sortedStates.forEach(state => {
//       const option = document.createElement("option");
//       option.value = state;
//       option.textContent = state;
//       dropdown.appendChild(option);
//     });

//     // Filter blocks function
//     function filterBlocks(selectedState) {
//       officeBlocks.forEach(block => {
//         block.style.display = block.getAttribute("data-state") === selectedState ? "" : "none";
//       });
//     }

//     // Auto-select first state and show only its addresses
//     if (sortedStates.length > 0) {
//       dropdown.value = sortedStates[0];
//       filterBlocks(sortedStates[0]);
//     }

//     // On dropdown change, filter accordingly
//     dropdown.addEventListener("change", function () {
//       filterBlocks(this.value);
//     });
// });

document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.getElementById("state-selector");
    const officeBlocks = document.querySelectorAll(".office-block");
    const stateCounts = {};

    // Count stores per state
    officeBlocks.forEach(block => {
        const state = block.getAttribute("data-state")?.trim();
        if (state) {
            stateCounts[state] = (stateCounts[state] || 0) + 1;
        }
    });

    // Sort states A-Z
    const sortedStates = Object.keys(stateCounts).sort((a, b) => a.localeCompare(b));

    // Populate dropdown with counts
    sortedStates.forEach(state => {
        const option = document.createElement("option");
        option.value = state;
        option.textContent = `${state} (${stateCounts[state]})`;
        dropdown.appendChild(option);
    });

    // Filter function
    function filterBlocks(selectedState) {
        officeBlocks.forEach(block => {
            block.style.display =
                block.getAttribute("data-state") === selectedState ? "" : "none";
        });
    }

    // Auto-select first state
    if (sortedStates.length > 0) {
        dropdown.value = sortedStates[0];
        filterBlocks(sortedStates[0]);
    }

    // On change
    dropdown.addEventListener("change", function () {
        filterBlocks(this.value);
    });
});